import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { useLocation } from 'react-router-dom';
import { ProfileLink, ProfileLinks as ProfileLinksComponent } from 'us-react-components/dist/ProfileLinks/ProfileLinks';

import { useDependencies } from '../../../dependencies';
import { getUrlFromPath, Routes } from '../../../Routes';
import { Storage } from '../../../constants';

const ProfileLinks = (): JSX.Element => {
  const { services: { tracker }, stores } = useDependencies();
  const location = useLocation();
  const { t } = useSharedTranslation(namespaces.caregiver);
  const id = stores.user.user.id?.toString() ?? '';

  const handleFeedbackClick = (): void => {
    localStorage.setItem(Storage.NPS_FEEDBACK_SOURCE, location.pathname);
  };

  const handleLogoutClick = (): void => {
    stores.user.logout();
  };

  const profileLinksSitter: ProfileLink[] = [
    {
      link: getUrlFromPath(Routes.sitter.yourFamilies, { id }),
      trackingTag: 'profile_links_your_families',
      label: t('components.header.profile.yourFamilies'),
      classes: 'font-bold',
    },
    {
      link: getUrlFromPath(Routes.sitter.settings, { id }),
      trackingTag: 'profile_links_settings',
      label: t('components.header.profile.settings'),
      classes: 'font-bold',
      hasHR: true,
    },
    {
      link: getUrlFromPath(Routes.credits, { id }),
      trackingTag: 'profile_links_credits',
      label: t('components.header.profile.credits'),
    },
    {
      link: getUrlFromPath(Routes.sitter.payout),
      trackingTag: 'profile_links_payout',
      label: t('components.header.profile.payout'),
    },
    {
      link: getUrlFromPath(Routes.transactions),
      trackingTag: 'profile_links_transactions',
      label: t('components.header.profile.transactions'),
    },
    {
      link: getUrlFromPath(Routes.sitter.successGuide),
      trackingTag: 'profile_links_success_guide',
      label: t('components.header.profile.successGuide'),
    },
    {
      link: getUrlFromPath(Routes.feedback),
      trackingTag: 'profile_links_give_feedback',
      label: t('components.header.profile.giveFeedback'),
      hasHR: true,
      isFeedback: true,
    },
    {
      trackingTag: 'profile_links_logout',
      label: t('components.header.profile.logout'),
      classes: 'text-sapphire font-bold',
      isLogOut: true,
    },
  ];

  const trackEvent = async (event: string, params?: {elementText: string}): Promise<void> => tracker.track(event, params);

  return <ProfileLinksComponent
    profileLinksArray={profileLinksSitter}
    handleFeedbackClick={handleFeedbackClick}
    handleLogoutClick={handleLogoutClick}
    trackingCallback={trackEvent}
  />
};

export { ProfileLinks };
